var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"visually-hidden",attrs:{"href":_vm.content,"id":"jump"}},[_vm._v(_vm._s(_vm.$t('jumpToContent')))])}
var staticRenderFns = []

export { render, staticRenderFns }